var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgKeyLargeIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 23,
    height: 13,
    viewBox: "0 0 23 13",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20.6375 4.16836L12.2875 4.17006C11.4671 1.84022 9.24672 0.170676 6.63672 0.171206C3.32672 0.171878 0.637265 2.86242 0.637937 6.17242C0.63861 9.48242 3.32916 12.1719 6.63916 12.1712C9.24915 12.1707 11.4688 10.5002 12.2883 8.17006L12.6383 8.16999L14.6387 10.1696L16.6383 8.16917L18.6387 10.1688L22.6379 6.12796L20.6375 4.16836ZM6.63855 9.1712C4.98855 9.17154 3.63827 7.82181 3.63794 6.17181C3.6376 4.52181 4.98733 3.17154 6.63733 3.17121C8.28733 3.17087 9.6376 4.5206 9.63794 6.1706C9.63827 7.8206 8.28855 9.17087 6.63855 9.1712Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgKeyLargeIcon);
export default __webpack_public_path__ + "static/media/KeyLargeIcon.73d476ba.svg";
export { ForwardRef as ReactComponent };